import React, { useState } from "react";
import { Modal } from "antd";

import { Comments } from "@arachnys/flow-app/src/component/Comments";
import { decodeId } from "@arachnys/flow-app/src/util";
import { commentsTags } from "./config";

const CommentsPopup = ({ request }) => {
    const [isOpen, setOpen] = useState(false);
    const setPopupState = state => () => setOpen(state);
    const requestId = decodeId(request.id);

    return (
        <>
            <a onClick={setPopupState(true)}>Comments</a>
            <Modal
                visible={isOpen}
                onCancel={setPopupState(false)}
                title={`Comments for ${request.name}`}
                footer={null}
            >
                <Comments roomID={requestId} tags={commentsTags} />
            </Modal>
        </>
    );
};

export default CommentsPopup;
